import { Controller } from "@hotwired/stimulus"
import { arrow, autoUpdate, computePosition, flip, offset, shift } from "@floating-ui/dom"

let tooltipId = 0

export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: "top" }
  }

  connect() {
    this.element.dataset.tooltipReady = "true"
  }

  disconnect() {
    this.hide()
    delete this.element.dataset.tooltipReady
  }

  show() {
    if (this.tooltip || !this.hasContentValue) return

    const tooltip = document.createElement("div")
    tooltip.id = `website-tooltip-${++tooltipId}`
    tooltip.className = "tooltip"
    tooltip.setAttribute("role", "tooltip")
    tooltip.setAttribute("data-turbo-temporary", "")

    const content = document.createElement("div")
    content.className = "tooltip-inner"
    content.textContent = this.contentValue
    tooltip.append(content)

    const arrowElement = document.createElement("div")
    arrowElement.className = "arrow"
    tooltip.append(arrowElement)

    document.body.append(tooltip)
    tooltip.style.display = "block"
    this.tooltip = tooltip
    this.element.setAttribute("aria-describedby", tooltip.id)
    this.stopPositioning = autoUpdate(this.element, tooltip, () => this.position(tooltip, arrowElement))
  }

  hide() {
    this.stopPositioning?.()
    this.stopPositioning = null
    this.element.removeAttribute("aria-describedby")
    this.tooltip?.remove()
    this.tooltip = null
  }

  async position(tooltip, arrowElement) {
    const { x, y, placement, middlewareData } = await computePosition(this.element, tooltip, {
      placement: this.placementValue,
      middleware: [offset(5), flip(), shift({ padding: 8 }), arrow({ element: arrowElement })]
    })
    if (this.tooltip !== tooltip) return

    Object.assign(tooltip.style, { left: `${x}px`, top: `${y}px` })
    const { x: arrowX, y: arrowY } = middlewareData.arrow || {}
    const staticSide = { top: "bottom", right: "left", bottom: "top", left: "right" }[placement.split("-")[0]]
    Object.assign(arrowElement.style, {
      left: arrowX == null ? "" : `${arrowX}px`,
      top: arrowY == null ? "" : `${arrowY}px`,
      right: "",
      bottom: ""
    })
    arrowElement.style[staticSide] = "-4px"
  }
}
